export default "__VITE_ASSET__CmadKoKY__"